import React from 'react';
import PropTypes from 'prop-types';
import { Radio, Spin } from 'antd';
import { connectToExclusiveStore } from '../Stores/ExclusiveStore';
import StepControlButtons from '../UI/StepControlButtons';
import VerifyCommunity from '../UI/VerifyCommunity';
import { Translate } from 'react-localize-redux';
import { VerifyCommunityStatus } from '../UI/VerifyCommunityStatus';

class ExclusiveStep extends React.Component {
	static propTypes = {
		exclusiveStore: PropTypes.shape({
			state: PropTypes.object,
			onRadioChange: PropTypes.func,
			cancelVerify: PropTypes.func,
			submitVerify: PropTypes.func,
			accessCodeChange: PropTypes.func,
		}),
		nextStep: PropTypes.func,
		previousStep: PropTypes.func,
		stepManagerDirection: PropTypes.number,
	};

	render() {
		const props = this.props;
		const { exclusiveStore: store } = props;
		const { state } = store;

		const selectedValue = state.selectedValue;
		const communities = state.communities;
		const community = communities[selectedValue];

		const joining = state.verifyStatus === VerifyCommunityStatus.Joining;
		const joined = state.verifyStatus === VerifyCommunityStatus.Joined;

		return (
			<div className="wizard-content">
				<h1>
					<Translate id="general_interest_communities" />
				</h1>
				<p>
					<Translate id="general_interest_communities_eligible" />
				</p>
				<div className="wizard-checkboxes">
					{this.renderContent(store, state)}
				</div>
				{state.selectedValue && (
					<VerifyCommunity
						community={community}
						code={state.accessCode}
						cancel={store.cancelVerify}
						submit={store.submitVerify}
						change={store.accessCodeChange}
						verifyStatus={state.verifyStatus}
					/>
				)}
				<p className="wizard-important-note">
					<span className="bold">
						<Translate id="important_note" />:
					</span>
					&nbsp;
					<Translate id="general_interest_communities_note" />
				</p>
				<StepControlButtons
					skip={!joined ? props.nextStep : null}
					goNext={joined ? props.nextStep : null}
					goBack={props.previousStep}
					nextDisabled={joining}
					backDisabled={joining}
				/>
			</div>
		);
	}

	componentDidMount() {
		const props = this.props;
		const { exclusiveStore: store } = props;
		const { state } = store;

		if (!this.hasCommunities(state.communities)) {
			if (props.stepManagerDirection > 0) {
				props.nextStep();
			} else {
				props.previousStep();
			}
		}
	}

	hasCommunities = communities => {
		return Object.keys(communities).length > 0;
	};

	renderContent = (store, state) => {
		const isLoading = state.isLoading;

		if (isLoading) {
			return (
				<Spin wrapperClassName="full-height">
					<div />
				</Spin>
			);
		}

		const onRadioChange = store.onRadioChange;
		const selectedValue = state.selectedValue;
		const communities = state.communities;
		const verifyStatus = state.verifyStatus;
		const joining = verifyStatus === VerifyCommunityStatus.Joining;
		const joined = verifyStatus === VerifyCommunityStatus.Joined;

		return (
			<Radio.Group onChange={onRadioChange} value={selectedValue}>
				{this.renderRadioButtons(communities, joining || joined)}
			</Radio.Group>
		);
	};

	renderRadioButtons = (communities, disabled) => {
		return Object.keys(communities).map(id =>
			this.renderRadioButton(communities[id], disabled),
		);
	};

	renderRadioButton = (community, disabled) => {
		return (
			<div key={community.id} className="wizard-radio">
				<Radio
					key={community.id}
					disabled={disabled}
					value={community.id}>
					{community.name}
				</Radio>
				<br />
			</div>
		);
	};
}

export default connectToExclusiveStore(ExclusiveStep);
